<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-select-filled
                    label="Type de mail"
                    v-model="mailView"
                    :items="mailItems"
                    item-value="value"
                    outlined
                    density="compact"
                    item-title="title"
                    class="pb-4"
                    data-cy="InvoiceMailSetting-mailType"
                >
                </v-select-filled>
            </v-col>
            <v-col cols="4"> </v-col>
        </v-row>
        <!-- Mail Templates -->
        <InvoiceMailTemplatesSetting
            v-if="mailView == 0"
            :defaultMails="defaultMails"
            @templateDelete="onMailTemplateDeleted"
        />
        <div v-if="mailView == 0">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.invoice">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 1">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.quote">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 2">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.deliveryBill">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 3">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.creditNote">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 4">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.deposit">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 5">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.reminder1">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 6">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.reminder2">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 7">
            <SingleLineMailEditor :isSignature="false" v-model="defaultMails.reminder3">
            </SingleLineMailEditor>
        </div>
        <div v-else-if="mailView == 8">
            <MultiLineMailEditor v-model="defaultMails.multipleReminder"></MultiLineMailEditor>
        </div>
        <div v-else-if="mailView == 9">
            <MultiLineMailEditor v-model="defaultMails.delay"> </MultiLineMailEditor>
        </div>

        <div class="py-2 mt-4 editor__container">
            <label for="mailSignature" class="editor__container__label">Signature du mail</label>
            <div class="d-flex align-stretch">
                <Editor
                    v-model="defaultMails.signature"
                    ref="signatureEditor"
                    id="mailSignature"
                    class="flex-grow-1"
                    :editorContentDataCy="'SingleLineMailEditor-mailSignature'"
                />
                <div class="d-flex flex-column editor__container__options">
                    <MailOptions
                        v-model:text="defaultMails.signature"
                        reference="signatureEditor"
                        @OnMailOptionSelected="updateSignature"
                    />
                    <div>
                        <v-btn-icon
                            icon="$fa-redo-alt"
                            size="small"
                            @click="defaultMails.signature = ''"
                            v-tooltip:bottom="'Remettre les valeurs par défauts'"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Editor from "@/components/editorMenu/Editor.vue";
import { MailEditorMixin, MailOptionData, TipTapEditor } from "@/components/mixins/mailEditorMixin";
import { defaultInvoiceMail } from "@/types/invoiceAdvanceSettings.types";
import InvoiceMailTemplatesSetting from "@/views/invoice/advanceSetting/InvoiceMailTemplatesSetting.vue";
import MailOptions from "@/views/mail/personaliseMail/MailOptions.vue";
import MultiLineMailEditor from "@/views/mail/personaliseMail/MultiLineMailEditor.vue";
import SingleLineMailEditor from "@/views/mail/personaliseMail/SingleLineMailEditor.vue";
import { Component, Prop, Ref, toNative } from "vue-facing-decorator";

@Component({
    components: {
        SingleLineMailEditor,
        MultiLineMailEditor,
        MailOptions,
        InvoiceMailTemplatesSetting,
        Editor,
    },
    emits: ["mailTemplateDelete"],
})
export class InvoiceMailSetting extends MailEditorMixin {
    @Prop() defaultMails: defaultInvoiceMail;

    @Ref() signatureEditor!: { editor: TipTapEditor };

    mailView: number = 0;

    mailViewingDialog: boolean = false;

    mailItems: any = [
        { title: "Mail de facture", value: 0 },
        { title: "Mail de devis", value: 1 },
        { title: "Mail de bon de livraison", value: 2 },
        { title: "Mail d'avoir", value: 3 },
        { title: "Mail d'acomptes", value: 4 },
        { title: "Mail de relance par défaut (dont multiples factures)", value: 8 },
        { title: "Mail de relance 1", value: 5 },
        { title: "Mail de relance 2", value: 6 },
        { title: "Mail de relance 3", value: 7 },
        { title: "Demande de retardement d'échéance", value: 9 },
    ];

    onMailTemplateDeleted() {
        this.$emit("mailTemplateDelete");
    }

    // loadNewCursorPos(data: any) {
    //     const textarea = this.signatureEditor!;

    //     this.$nextTick(() => {
    //         textarea.selectionStart = data.newCursorPos;
    //         textarea.selectionEnd = textarea.selectionStart;
    //         textarea.focus();
    //     });
    // }

    updateSignature(data: MailOptionData): void {
        this.updateEditorContentWithMailOption(
            data,
            this.signatureEditor,
            "defaultMails.signature",
        );
    }
}

export default toNative(InvoiceMailSetting);
</script>

<style lang="scss" scoped>
.editor {
    &__container {
        background-color: #ececec;
        border-radius: 12px;
        &__label {
            color: black;
            font-size: 12.5px;
            margin-left: 1rem;
            opacity: 0.6;
        }
        &__options {
            margin: 0 13.5px;
            flex-shrink: 0;
            width: 28px;
        }
    }
}
</style>
